import React, { useEffect, useState } from 'react';
import SwitchLang from './SwitchLang';
import parse from 'html-react-parser';
import { Checkbox, Divider } from 'antd';
import GlobalService from '../../../../../services/Global.service';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import months from '../../../months.json';

export default function Preview({
    value,
    imageId,
    consent,
    selectDocLayout,
    templateDetail,
}) {
    const { t } = useTranslation();
    const [previewLang, setPreviewLang] = useState('th');
    const [imageSrc, setImageSrc] = useState([]);
    const [isAccept, setIsAccept] = useState(false);

    const Title = styled.div`
        font-weight: 600 !important;
    `;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return previewLang === 'th' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return previewLang === 'th' ? year + 543 : year;
    };

    const getCurrentDate = (date) => {
        const currentDate = new Date(date);
        const day = currentDate.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };

    useEffect(() => {
        const getImage = async () => {
            try {
                const { data } = await GlobalService.getImage(imageId);
                if (data.resultData?.imageId) {
                    setImageSrc(
                        `data:image/png;base64,${data.resultData?.imageId}`
                    );
                }
            } catch (error) {
                console.log(error);
            }
        };
        if (imageId) getImage();
        else setImageSrc(null);
    }, [imageId]);

    return (
        <>
            <div className="bg-white rounded-md p-5">
                <div className="flex justify-between">
                    <div>
                        <SwitchLang
                            previewLang={previewLang}
                            setPreviewLang={setPreviewLang}
                        />
                    </div>
                    <div hidden={!templateDetail?.updateBy}>
                        <span className="font-semibold">
                            {t('Last Updated')} :&nbsp;
                        </span>
                        <span>
                            {templateDetail?.updateBy},{' '}
                            {templateDetail?.updateDate}
                        </span>
                    </div>
                </div>

                <div className="rounded-xl border-1 border-solid border-[#EDEEF9] m-4 px-5 py-6 min-h-[500px]">
                    {imageSrc && (
                        <center>
                            <img
                                className="object-cover rounded"
                                src={imageSrc}
                                height={70}
                                alt={value?.titleEn}
                            />
                        </center>
                    )}
                    <Title className="text-[#1E1E1E] text-xl text-center pt-3">
                        {previewLang === 'th'
                            ? parse(value?.titleTh || '') || ''
                            : parse(value?.titleEn || '') || ''}
                    </Title>
                    <Divider className="my-4" />
                    <Title>
                        {previewLang === 'th'
                            ? parse(value?.templateNameTh || '') || ''
                            : parse(value?.templateNameEn || '') || ''}
                    </Title>
                    {previewLang === 'th'
                        ? parse(consent?.purposeTh || '') || ''
                        : parse(consent?.purposeEn || '') || ''}
                    <div>
                        {previewLang === 'en'
                            ? `This document was last updated on ${getCurrentDate(
                                  value?.effectiveDate
                                      ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                                      ?.split('T')[0]
                                      ?.split('T')[0] || '-'
                              )}`
                            : `เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อ ${getCurrentDate(
                                  value?.effectiveDate
                                      ?.format('YYYY-MM-DDT00:00:00.000+00:00')
                                      ?.split('T')[0]
                                      ?.split('T')[0] || '-'
                              )}`}
                    </div>
                    <div hidden={selectDocLayout !== 2} className="mt-3">
                        <Checkbox
                            className="bg-[#F4F6FC] rounded-md px-3 py-[10px]"
                            checked={isAccept}
                            onChange={(e) => {
                                setIsAccept(e.target.checked);
                            }}
                        >
                            <div>
                                {previewLang === 'en'
                                    ? 'Agree to the terms and conditions.'
                                    : 'รับทราบข้อกำหนดและเงื่อนไข'}
                            </div>
                        </Checkbox>
                        <Divider className="my-3" />
                        <div className="font-semibold">
                            {previewLang === 'en'
                                ? 'Provide consent information as of (date) ...'
                                : 'ให้ข้อมูลความยินยอม ณ วันที่ ...'}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
